if (!customElements.get('lp-product-selector')) {
    class LpProductSelector extends HTMLElement {
        constructor() {
            super();
            if (typeof Carousel === 'undefined') {
                const script = document.createElement('script');
                script.setAttribute('src', window.carouselJS);
                script.setAttribute('defer', '')
                document.head.appendChild(script);
                script.onload = () => this.initCarousel();
            } else {
                this.initCarousel();
            }
            this.hydrateBundles()
        }
        initCarousel() {
            new Carousel(this, {
                slidesPerPage: 1,
                infinite: false,
                Dots: false,
                initialSlide: Number(this.dataset.initialSlide),
                classes: {
                    slide: "lp-product"
                },
                Navigation: {
                    nextTpl: '<svg><use href="#arrow-right"></use></svg>',
                    prevTpl: '<svg><use href="#arrow-left"></use></svg>'
                },
                breakpoints: {
                    '(min-width: 1024px)': {
                        enabled: false
                    }
                }
            })
        }
        hydrateBundles() {
            if (!window.lpProducts?.length) {
                return;
            }
            window.lpProducts.forEach((lpProduct, lpIndex) => {
                lpProduct.bundle_options.forEach((option, index) => {
                    if (option.initialProducts?.length === option.minimumQuantity) return false;
                    const availableProducts = option.products.filter(product => product.available && product.inventory_quantity > lpProduct.increment)
                    let initialProducts = []
                    while (initialProducts.length < option.minimumQuantity) {
                        availableProducts.forEach(product => {
                            product.used_quantity = product.used_quantity || 0 // track how many have been added
                            if (initialProducts.length < option.minimumQuantity && product.inventory_quantity >= product.used_quantity) {
                                initialProducts = [...initialProducts, ...Array.from({length: lpProduct.increment}, () => product)]
                                product.used_quantity += lpProduct.increment
                            }
                        })
                    }
                    window.lpProducts[lpIndex].bundle_options[index].initialProducts = [...initialProducts]
                })
            })
        }
    }

    customElements.define('lp-product-selector', LpProductSelector);
}
if (!customElements.get('lp-product')) {
    class LpProduct extends HTMLElement {
        constructor() {
            super();
            this.drawerSelector = 'bundle-customiser-drawer';
            this.qtySelector = '[data-role="qty-value"]';
            this.minusSelector = '[data-role="qty-minus"]';
            this.qty = 1;
        }
        payload() {
            const bundle_options = []
            const option_text = {}
            this.querySelectorAll(this.drawerSelector).forEach(drawer => {
                if (Number(drawer.dataset.multiple)) {
                    for (const variantId in drawer.selections) {
                        if (drawer.selections[variantId] === 0 || !variantId) {
                            continue;
                        }
                        let i = 1;
                        Array(drawer.selections[variantId]).fill(0).forEach(_i => {
                            bundle_options.push(Number(variantId))
                            option_text['_' + drawer.dataset.label + ' ' + i++] = this.getVariantHandle(Number(variantId));
                        });
                    }
                } else {
                    bundle_options.push(drawer.selectedProduct);
                    option_text['_' + drawer.dataset.label + ' 1'] = this.getVariantHandle(drawer.selectedProduct);
                }
            });
            const bundleKey = () => {
                const str = bundle_options.map((variantId, qty) => {
                    return `${variantId}-${qty}`
                }).join('-')

                let hash = 0
                for (let i = 0; i < str.length; i++) {
                    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0
                }
                return (hash >>> 0).toString(36)
            }
            return {
                items: [
                    {
                        id: Number(this.dataset.productId),
                        quantity: this.qty,
                        properties: {
                            ...{
                                _bundle_parent: true,
                                _bundle_options: bundle_options,
                                _bundle_key: bundleKey()
                            }, ...option_text
                        }
                    }
                ]
            }
        }
        getVariantHandle(variantId) {
            return lpProducts
                .find(product => product.id === Number(this.dataset.bundleId))?.bundle_options
                .find(option => option.products.find(product => product.variantId === variantId))?.products
                .find(product => product.variantId === variantId)?.handle
        }
        addToCart() {
            if (this.querySelector('.invalid')) return false;
            const payload = this.payload();
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
                .then((response) => response.json())
                .then((response) => {
                    document.dispatchEvent(new Event('cartItemAdded'))
                }).catch((error) => {
                console.error('Error:', error);
            })
        }
        decreaseQty() {
            if (this.qty > 0) {
                this.qty -= 1;
                this.setQtyInput()
            }
            if (this.qty === 0) {
                this.querySelector(this.minusSelector).setAttribute('disabled', '')
            }
        }
        increaseQty() {
            this.qty += 1;
            this.setQtyInput()
            this.querySelector(this.minusSelector).removeAttribute('disabled')
        }
        setQtyInput() {
            this.querySelector(this.qtySelector).value = this.qty;
        }
    }

    customElements.define('lp-product', LpProduct);
}
if (!customElements.get('bundle-customiser-drawer')) {
    class BundleCustomiserDrawer extends HTMLElement {
        constructor() {
            super();
            document.addEventListener('DOMContentLoaded', () => {
                this.multiple = Number(this.dataset.multiple);
                this.qtySelector = '[data-role="drawer-qty"]';
                this.selectedSingleClass = "product-slideout__grid-item--active"
                this.selectedMultipleClass = "product-slideout-qty-item--active"
                this.increaseSelector = '[data-role="increase-qty"]'
                this.buttonTextSelector = '[data-role="bundle-selection-list"]'
                this.buttonImageSelector = '[data-role="bundle-selection-image"]'
                this.selectedQtySelector = '[data-role="selected-qty"]'
                if (!this.multiple) {
                    this.selectedProduct = false;
                    this.qty = 1;
                } else {
                    this.selections = {};
                }
                if (this.multiple) {
                    // set initial qty to 0 for all variants
                    this.getBundleOptions()?.products.forEach(product => this.selections[product.variantId] = 0)
                    // set initial selection status and qty
                    this.getSelectionInitialProducts()?.forEach(product => {
                        this.selections[product.variantId] = product.used_quantity
                        this.setQtyInput(product.variantId);
                    })
                    this.updateMultipleSelectionClasses()
                } else {
                    const selectedProducts = this.getSelectionInitialProducts();
                    if (selectedProducts) {
                        this.querySelector(`[data-item-id="${selectedProducts[0].variantId}"]`)
                            .classList.add(this.selectedSingleClass);
                        this.selectedProduct = selectedProducts[0].variantId;
                    }
                }
            })
        }
        getBundleOptions() {
            return lpProducts
                .find(product => product.id === Number(this.dataset.bundleId))?.bundle_options
                .find(option => option.selectionIndex === Number(this.dataset.selectionIndex));
        }
        getSelectionInitialProducts() {
            return this.getBundleOptions()?.initialProducts
        }
        open() {
            const scrollY = window.scrollY || window.pageYOffset;
            this._scrollY = scrollY;
            this.classList.add('active');
            document.body.classList.add('bundle-drawer-open');
            document.body.style.top = `-${scrollY}px`;
            // Dispatch custom event when slideout opens
            document.dispatchEvent(new CustomEvent('hidePDPNavigationButtons', {
                detail: { source: 'bundle-customiser-drawer' }
            }))
        }
        close() {
            const scrollY = this._scrollY ?? 0;
            this.classList.remove('active');
            const anyActive = document.querySelector('bundle-customiser-drawer.active');
            if (!anyActive) {
                document.body.classList.remove('bundle-drawer-open');
                document.body.style.top = '';
                if (scrollY) window.scrollTo(0, scrollY);
            }
            // Dispatch custom event when slideout closes
            document.dispatchEvent(new CustomEvent('showPDPNavigationButtons', {
                detail: { source: 'bundle-customiser-drawer' }
            }))
        }
        closeAll() {
            document.querySelectorAll(this.tagName, drawer => drawer.classList.remove('active'))
        }
        /**
         * Update single selection where only one is required
         * @param id
         */
        selectProduct(id) {
            this.querySelectorAll('[data-item-id]').forEach(item => item.classList.remove(this.selectedSingleClass));
            this.querySelector(`[data-item-id="${id}"]`).classList.add(this.selectedSingleClass);
            this.updateSelection(this.getVariant(id)?.name);
            this.updateSelectionImage(this.getVariant(id)?.buttonImage);
            this.selectedProduct = id;

            this.close()
        }
        increaseQty(id) {
            if (!this.getIsMaxReached()) {
                this.selections[id] += 1;
                this.updateSelections(id);
            }
        }
        decreaseQty(id) {
            if (this.selections[id] > 0) {
                this.selections[id] -= 1;
                this.updateSelections(id);
            }
        }
        updateSelections(id) {
            this.setQtyInput(id);
            const selections = [];
            let image = false
            for (const variantId in this.selections) {
                if (this.selections[variantId] > 0) {
                    selections.push(this.getVariant(variantId)?.name)
                    image = image || this.getVariant(variantId)?.buttonImage
                }
            }
            // update button
            this.updateSelection(selections.join(', '));
            this.updateSelectionImage(image);
            // update selected count text
            document.querySelector(`bundle-customiser[data-bundle-id="${this.dataset.bundleId}"] ${this.selectedQtySelector}[data-selection-index="${this.dataset.selectionIndex}"]`).innerText = this.getTotalSelected()
            // update item classes
            this.updateMultipleSelectionClasses();
            const trigger = this.updateSelectionElement(this.buttonTextSelector).closest(`[data-drawer-id]`)
            if (this.getTotalSelected() >= this.getBundleOptions().minimumQuantity) {
                trigger.classList.remove('invalid');
            } else {
                trigger.classList.add('invalid');
            }
        }
        /**
         * Update the selection input and set disabled based on qty/max comparison
         * @param id
         */
        setQtyInput(id) {
            const input = this.querySelector(`[data-item-id="${id}"] ${this.qtySelector}`)
            input.value = this.selections[id]
            this.querySelectorAll(this.increaseSelector).forEach(selector => this.getIsMaxReached() ? selector.setAttribute('disabled', '') : selector.removeAttribute('disabled'))
        }
        getTotalSelected() {
            return Object.values(this.selections).reduce((a, b) => a + b, 0);
        }
        /**
         * Check if the maximum number of allowed products is reached as defined by selection metafield
         * @returns {boolean}
         */
        getIsMaxReached() {
            return this.getTotalSelected() >= this.getBundleOptions(this.dataset.selectionIndex).maximumQuantity;
        }
        /**
         * Update the selection button with the selected variant name
         * @param content String
         */
        updateSelection(content = '') {
            this.updateSelectionElement(this.buttonTextSelector, 'innerText', content);
        }
        updateSelectionImage(url) {
            if (!url) return;
            this.updateSelectionElement(this.buttonImageSelector, 'src', url);
            this.updateSelectionElement(this.buttonImageSelector, 'srcset', url);
        }
        updateSelectionElement(selector, property = '', value = '') {
            const element = document.querySelector(`bundle-customiser[data-bundle-id="${this.dataset.bundleId}"] ${selector}[data-selection-index="${this.dataset.selectionIndex}"]`);
            if (element) {
                element[property] = value;
            }
            return element;
        }
        getVariant(id) {
            return this.getBundleOptions()?.products.find(product => product.variantId === Number(id));
        }
        getVariantImage(id) {
            return this.getVariant(id)?.name;
        }
        updateMultipleSelectionClasses() {
            for (const variantId in this.selections) {
                if (this.selections[variantId] > 0) {
                    this.querySelector(`[data-item-id="${variantId}"]`).classList.add(this.selectedMultipleClass);
                } else {
                    this.querySelector(`[data-item-id="${variantId}"]`).classList.remove(this.selectedMultipleClass);
                }
            }
        }
    }

    customElements.define('bundle-customiser-drawer', BundleCustomiserDrawer);
}

if (!customElements.get('bundle-customiser')) {
    class BundleCustomiser extends HTMLElement {
        constructor() {
            super();
            document.addEventListener('DOMContentLoaded', () => {
                this.querySelectorAll('[data-role="bundle-selection-list"]').forEach(list => {
                    const bundleOption = lpProducts
                        ?.find(product => product.id === Number(this.dataset.bundleId))?.bundle_options
                        ?.find(option => option.selectionIndex === Number(list.dataset.selectionIndex));
                    const initialProducts = bundleOption?.initialProducts;
                    if (initialProducts && initialProducts.length) {
                        list.innerHTML = initialProducts
                            .map(product => product.name)
                            .filter(name => name) // Filter out undefined names
                            .join(', ') || list.innerHTML; // Keep original if empty
                    }
                })
            })
        }
        openDrawer(element) {
            this.closest('lp-product').querySelector(`bundle-customiser-drawer[data-id="${element.dataset.drawerId}"]`).open()
        }
    }

    customElements.define('bundle-customiser', BundleCustomiser);
}
